import React from 'react';
import { SdfAlert, SdfButton, SdfDatePicker } from '@synerg/react-components';

export const SubmitScopeStep = (props) => {
	const {
		cutOffDate,
		submitChangeRequest,
		setCutOffDate,
		completed = false,
		setLoadModifyScope,
		setModifyScopeSuccess
	} = props;

	return (
		<div className="w-full">
			<div className="text-heading-05 font-bold">Next steps</div>
			<div className="w-full mt-10">
				<SdfAlert status="success" type="banner" size="sm">
					{completed &&
						<>
							<span>Success! Your scope changes have been successfully added to your project.</span>
							<SdfButton slot="action" onClick={() => {
								setLoadModifyScope(false);
								setModifyScopeSuccess(true);
							}}>
								Done
							</SdfButton>
						</>
					}
					{!completed &&
						<span>Success! Your scope changes were successfully added to your change request.</span>
					}
				</SdfAlert>
			</div>

			{completed === false ? (
				<>
					<div className="text-heading-04 font-bold mt-10">
						Next, please schedule when the preauthorization period should end.
					</div>

					<div className="text-body-01 mt-2">
						This is the date that clients must provide preauthorization before
						their data exchange is paused. Note: this date can be modified later
						on the project’s subscription tab.
					</div>

					<div className="flex items-center mt-6 gap-10">
						<div>
							<SdfDatePicker
								hideLabel={true}
								rules={[{
									type: "DISABLED",
									startDateInclusive: new Date(0, 0, 0),
									endDateInclusive: new Date().setDate(new Date().getDate() - 1)
								}]}
								value={cutOffDate}
								onSdfChange={({ detail }) => {
									setCutOffDate(detail);
								}}
								placeholder="MM/DD/YYYY"
								className="min-w-72"
							/>
						</div>
						<div className="w-2/5">
							<SdfButton className="primary" onClick={submitChangeRequest}>
								Save and schedule
							</SdfButton>
						</div>
					</div>
					<div className="w-4/5 mt-6">
						<SdfAlert status="info" type="banner" size="sm">
							<span data-cvs-id="4">
								Please note that the scope and any corresponding authorization
								text will not change in the consumer app registry until the
								preauthorization cutoff date arrives.
							</span>
							<span data-cvs-id="6" slot="title">
								Note the effective date
							</span>
						</SdfAlert>
					</div>
				</>
			) : null}
		</div>
	);
};
